import React, { useState } from 'react';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';
import { VanityLinkModal } from '#src/app/pages/starterDashboardV2/shared/components';
import { VanityLinkModalContext } from '#src/app/pages/starterDashboardV2/shared/contexts';
import { VanityModalStateContextProvider } from '#src/app/pages/starterDashboardV2/shared/hooks';

export const VanityLinkModalWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const [isOpen, setIsOpen] = useState(false);

	const openModal = () => {
		setIsOpen(true);
	};

	const closeModal = () => {
		setIsOpen(false);
	};

	const contextValue = { openModal, closeModal };

	return (
		<VanityLinkModalContext.Provider value={contextValue} data-qa="vanity-link-modal-context">
			{children}
			{isOpen && (
				<VanityModalStateContextProvider>
					<VanityLinkModal
						isOpen={isOpen}
						onClose={closeModal}
						petitionId={petition.id}
						petitionSlug={petition.slug}
						displayedSignatures={petition.signatureState.signatureCount.displayed}
						data-qa="vanity-link-modal"
					/>
				</VanityModalStateContextProvider>
			)}
		</VanityLinkModalContext.Provider>
	);
};
